import { EdgeEditAnnouncementRepository } from '@/modules/connect/infra'
import type { EditAnnouncement } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeEditAnnouncement(): EditAnnouncement {
  return new EdgeEditAnnouncementRepository(makeSupabaseEdgeHttpClient()).execute
}
